// extracted by mini-css-extract-plugin
export default {"playerWrapper":"styles-module__playerWrapper__da58aeddb4bff673e937","reactPlayer":"styles-module__reactPlayer__e65a97e5812612dd86f8"};